"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectMenu = void 0;
const react_1 = __importStar(require("react"));
const BaseComponents_1 = require("./BaseComponents");
const CheckBox_1 = require("../CheckBox/CheckBox");
const MultiSelectContainer = (props) => {
    const { onOptionSelected, menuLocation, menuOptions, fontSize } = props;
    const createCheckedItems = (options) => {
        return options.reduce((a, v) => {
            if (v.checked) {
                return [...a, v.text];
            }
            else {
                return a;
            }
        }, []);
    };
    const initialCheckedItems = createCheckedItems(menuOptions);
    const [currentState, updateCurrentState] = react_1.useState(initialCheckedItems);
    const handleOptionClicked = (target) => {
        const shouldItemBeRemoved = currentState.includes(target);
        const result = shouldItemBeRemoved ? 'removed' : 'added';
        const newCheckedItems = shouldItemBeRemoved
            ? currentState.filter((item) => item != target)
            : [...currentState, target];
        updateCurrentState(newCheckedItems);
        onOptionSelected(target, result);
    };
    react_1.useEffect(() => {
        updateCurrentState(createCheckedItems(menuOptions));
    }, [menuOptions]);
    return (react_1.default.createElement(BaseComponents_1.MenuContainer, { className: "MultiSelectMenuContainer", menuLocation: menuLocation }, menuOptions.map((option) => (react_1.default.createElement(BaseComponents_1.MenuItem, { key: `MultiSelectMenu_${option.text}`, onClick: () => handleOptionClicked(option.text) },
        react_1.default.createElement(CheckBox_1.CheckBox, { key: `MultiSelectMenu_${option.text}_CheckboxField`, onClick: () => {
                return;
            }, checked: currentState.includes(option.text), text: option.text, fontSize: fontSize }))))));
};
exports.MultiSelectMenu = (props) => {
    const [isMenuOpen, setMenuOpen] = react_1.useState(false);
    const wrapperRef = react_1.useRef(null);
    const handleOutsideClick = (event) => {
        var _a;
        const el = event.target;
        isMenuOpen && !((_a = wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(el)) && setMenuOpen(false);
    };
    react_1.useEffect(() => {
        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [isMenuOpen]);
    const handleParentClick = () => {
        setMenuOpen(!isMenuOpen);
    };
    const ClonedVisualEle = react_1.cloneElement(props.VisualElement, {
        onClick: handleParentClick,
    });
    return (react_1.default.createElement(BaseComponents_1.MenuComponentWrapper, { className: "MultiSelectMenu", ref: wrapperRef },
        ClonedVisualEle,
        isMenuOpen && react_1.default.createElement(MultiSelectContainer, Object.assign({}, props))));
};
//# sourceMappingURL=MultiSelectMenu.js.map